import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { ProductionService } from '../../../services/production.service';
import { RouterService } from '../../../services/router.service';
import { SrvLocationService } from '../../../services/SrvLocation.service';
import { SystemInternalService } from '../../../services/systemInternal.service';
import { UserService } from '../../../services/user.service';
import { IGetConfigurationCodeV3 } from '../../Interfaces/iconfig';
import { IPASInProduction } from '../../Interfaces/iproduction';

declare interface Location {
  locationName: string;
  userName: string;
  difference: string;
  differenceMinutes: number;
  percentage: number;
  class: string;
}

@Component({
  selector: 'kdsviewer-data',
  templateUrl: './kdsviewer.component.html'
})

export class KdsViewerComponent {
  constructor(
    private router: Router,
    //private locationService: LocationService,
    //private securityParams: ActivatedRoute,
    private productionService: ProductionService,
    //private prdLocationService: PrdLocationService,
    private srvLocationService: SrvLocationService,
    private _snackBar: MatSnackBar,
    private routerService: RouterService,
    private systemInternalService: SystemInternalService,
    private userService: UserService
  ) {
    this._timer = setInterval(() => this.loadServiceLocations(), 15000);
    this.SetIntervalProduction()
  }

  menuLocations: any[];
  _result: boolean = false;
  locations: Location[];
  menuPasIn: IPASInProduction[];
  menuPasInProduction: IPASInProduction[];
  menuPasDeleted: IPASInProduction[];
  registryTimeout: number;
  messageLocations: string = "";
  _timer: any;
  _productionTimer: any;
  _buttonPrdToInTimer: any;
  _ClickProductionModeNext: boolean = true;
  _FontSizeTitle: string = "15px";
  _FontSizeSubtitle: string = "13px";
  _FontSizeComment: string = "13px";
  _FontSizeTime: string = "10px";
  _PasInFilter: number = 0;
  _IntervalProductionOn: boolean = true;
  myId: number = 0;
  Iteractions: number = 0;


  async ngOnInit() {
    const _Config: IGetConfigurationCodeV3 = {
      code: "KDSFNTSIZE", parentCode: "KDSA"
    }
    this.userService.GetMyId().subscribe(result => {
      if (result.body.isValid) {
        this.myId = result.body.resultData.id;
      }
    },
      (e) => {
        console.log(e);
      });
    this.systemInternalService.GetConfiguration(_Config).subscribe(result => {
      if (result.body.isValid) {
        if (result.body.resultData.numbervalue >= 15 && result.body.resultData.numbervalue <= 30) {
          this._FontSizeTitle = result.body.resultData.numbervalue.toString().trim() + "px";
          this._FontSizeSubtitle = (result.body.resultData.numbervalue - 2).toString() + "px";
          this._FontSizeComment = (result.body.resultData.numbervalue - 4).toString() + "px";
          this._FontSizeTime = (result.body.resultData.numbervalue - 7).toString() + "px";
        }
      }
    },
      (e) => {
        console.log(e);
      });
    this.locations = [];
    this.menuLocations = [];
    this.loadServiceLocations();
    this.loadPASInProduction();
    //
    this.menuPasIn = [];
    this.menuPasInProduction = [];
    this.menuPasDeleted = [];
  }

  ngOnDestroy(): void {
    clearInterval(this._timer);
    this.ClearIntervalProduction();
  }

  SetIntervalProduction() {
    this._IntervalProductionOn = true;
    this._productionTimer = setInterval(() => {
      this.loadPASInProduction();
    }, 15000, 15000);
  }

  ClearIntervalProduction() {
    this._IntervalProductionOn = false;
    if (this._productionTimer) {
      clearInterval(this._productionTimer);
    }
  }

  private async loadServiceLocations() {
    this.srvLocationService.GetServiceLocationsInProduction(0).subscribe(result => {
      if (result.body.isValid) {
        this.locations = [];
        this.menuLocations = [];
        for (const entry of result.body.resultData) {
          this.addLocations({
            locationName: entry.locationName.substring(0, 20).trim(), userName: entry.userName.substring(0, 20).trim(), difference: entry.difference.substring(0, 20),
            differenceMinutes: entry.differenceMinutes, percentage: entry.percentage, class: entry.function_class, color01: entry.color01, color02: entry.color02
          });
        }
        this.menuLocations = this.locations;
        this.messageLocations = "";

      }
      else {
        if (result.body.error.code == 204) {
          this.locations = [];
          this.menuLocations = [];
          this.messageLocations = result.body.error.description;
        }
        else {
          alert(result.body.error.description);
        }
      }
    },
      (e) => {
        console.log(e);
      });
    return this.locations;
  }

  private async loadPASInProduction() {
    if (!this._IntervalProductionOn)
      return;
    this.productionService.GetPASinProductionV2(0, 0)
      .subscribe(result => {
        if (result.body.isValid) {
          for (const entry of result.body.resultData) {
            if (entry.children == 0) {
              var _Item = this.menuPasIn.find(x => x.id == entry.id);
              if (!_Item) {
                var _Item = this.menuPasInProduction.find(x => x.id == entry.id);
                if (!_Item)
                  _Item = this.menuPasDeleted.find(x => x.id == entry.id);
              }
              if (_Item) {
                _Item.updated = true;
                _Item.difference = entry.difference.substring(0, 20);
                _Item.differenceMinutes = entry.differenceMinutes;
                _Item.onTime = entry.onTime; _Item.color01 = entry.color01; _Item.color02 = entry.color02, _Item.color03 = entry.color03;
                //Updated: 20/Nov/2024
                // 8/march/2025
                if (entry.status != _Item.status && entry.userPrdId != this.myId) { //_StatusOri
                  _Item.status = entry.status;
                  var _Children = result.body.resultData.find(x => x.parentId == entry.id)
                  if (!_Children) {
                    switch (entry.status) {
                      case "R":
                        this.MoveScreenItemToIn(entry.id);
                        break;
                      case "P":
                        this.MoveScreenItemToProduction(entry.id);
                        break;
                      default:
                        this.MoveScreenItemToOut(entry.id);
                        break;
                    }
                  }
                }
              }
              else {
                if ((this.Iteractions == 0 || entry.userPrdId != this.myId)) {
                  switch (entry.status) {
                    case "R":
                      entry.userPrdId = this.myId;
                      this.addPASIn(entry);
                      this.MoveScreenItemToIn(entry.id);
                      break;
                    case "P":
                      entry.userPrdId = this.myId;
                      this.addPASInProduction(entry);
                      this.MoveScreenItemToProduction(entry.id);
                      break;
                    default:
                      this.MoveScreenItemToOut(entry.id);
                  }
                  if (entry.parentId > 0) {
                    switch (entry.status) {
                      case "R":
                        var _ItemParent = this.menuPasIn.find(x => x.id == entry.parentId);
                        if (!_ItemParent) {
                          var _ItemParent = result.body.resultData.find(x => x.id == entry.parentId && x.status == entry.status);
                          _ItemParent.onTime = 1;
                          _ItemParent.userPrdId = this.myId;
                          this.addPASInContainer(_ItemParent, _ItemParent.difference);
                        }
                        break;
                      case "P":
                        var _ItemParent = this.menuPasInProduction.find(x => x.id == entry.parentId);
                        if (!_ItemParent) {
                          var _ItemParent = result.body.resultData.find(x => x.id == entry.parentId && x.status == entry.status);
                          _ItemParent.userPrdId = this.myId;
                          this.addPASInProductionContainer(_ItemParent);
                        }
                        break;
                    }
                  }
                }
              }
            }
            else {
              switch (entry.status) {
                case "R":
                  var _Item = this.menuPasIn.find(x => x.id == entry.id);
                  break;
                case "P":
                  var _Item = this.menuPasInProduction.find(x => x.id == entry.id);
                  break;
                default:
                  _Item = this.menuPasDeleted.find(x => x.id == entry.id);
                  break;
              }

              if (_Item) {
                _Item.difference = entry.difference.substring(0, 20);
                _Item.differenceMinutes = entry.differenceMinutes;
                _Item.onTime = entry.onTime; _Item.color01 = entry.color01; _Item.color02 = entry.color02, _Item.color03 = entry.color03;
                if (entry.userPrdId != this.myId) {
                  _Item.status = entry.status;
                  _Item.updated = true;
                }
              }
            }
          }
          this.Iteractions++;
        }
        else {
          if (result.body.error.code == 204) {
            this.menuPasIn = [];
            this.menuPasInProduction = [];
          }
          else {
            alert(result.body.error.description);
          }
        }
      },
        (e) => {
          console.log(e);
        });

    return this.locations;
  }

  addLocations(route) {
    this.locations.push(route);
  }

  addPASInContainer(route, difference: string) {
    this.menuPasIn.push({
      id: route.id, color01: route.color01, color02: route.color02, color03: route.color03, compType: route.compType, difference: difference, // route.difference.substring(0, 20)
      differenceMinutes: route.differenceMinutes, function_class: route.function_class, locationName: route.locationName.substring(0, 20).trim(), onTime: route.onTime,
      parentId: route.parentId, pasNameUm: route.pasNameUm, quantity: route.quantity, requestOrder: route.requestOrder, status: "R", textOptions: route.textOptions,
      userPrdId: route.userPrdId, updated: true, children: route.children, locationProductionId:route.locationProductionId
    });
  }

  addPASInProductionContainer(route) {
    this.menuPasInProduction.push({
      id: route.id, color01: route.color01, color02: route.color02, color03: route.color03, compType: route.compType, difference: route.difference.substring(0, 20),
      differenceMinutes: route.differenceMinutes, function_class: route.function_class, locationName: route.locationName.substring(0, 20).trim(), onTime: route.onTime,
      parentId: route.parentId, pasNameUm: route.pasNameUm, quantity: route.quantity, requestOrder: route.requestOrder, status: "P", textOptions: route.textOptions,
      userPrdId: route.userPrdId, updated: true, children: route.children, locationProductionId: route.locationProductionId
    });
  }


  addPASIn(route) {
    var _Item = this.menuPasIn.find(x => x.id == route.id);
    if (!_Item) {
      route.locationName = route.locationName.substring(0, 20).trim();
      route.difference = route.difference.substring(0, 20);
      route.updated = true;
      this.menuPasIn.push(route);
    }
  }

  addPASInProduction(route) {
    route.locationName = route.locationName.substring(0, 20).trim();
    route.difference = route.difference.substring(0, 20);
    route.updated = true;
    this.menuPasInProduction.push(route);
  }

  filterPasInGroups() {
    try {
      if (this.menuPasIn.length > 0) {
        return this.menuPasIn.filter(x => x.parentId == 0);
      }
      else {
        return this.menuPasIn;

      }
    } catch {
      return null;
    }
  }

  filterPasIn(idparent) {
    return this.menuPasIn.filter(x => x.parentId == idparent);
  }

  filterPasPrdGroups() {
    try {
      if (this.menuPasInProduction.length > 0) {
        return this.menuPasInProduction.filter(x => x.parentId == 0);
      }
      else {
        return this.menuPasInProduction;

      }
    } catch {
      return null;
    }
  }

  filterPasPrd(idparent) {
    return this.menuPasInProduction.filter(x => x.parentId == idparent);
  }

  MoveScreenItemToProduction(Id) {
    //drop parent container
    var _Item = this.menuPasIn.find(x => x.id == Id);
    if (_Item && _Item.parentId > 0) {
      var _Children = this.menuPasIn.filter(x => x.parentId == _Item.parentId);
      var _ItemParent = this.menuPasInProduction.find(x => x.id == _Item.parentId);
      if (!_ItemParent) {
        var _ItemParent = this.menuPasIn.find(x => x.id == _Item.parentId);
        if (_ItemParent) {
          _ItemParent.userPrdId = this.myId;
          _ItemParent.onTime = 1;
          this.addPASInProductionContainer(_ItemParent);
        };
      }
      if (_Children.length == 1) {
        this.menuPasIn = this.menuPasIn.filter(x => x.id != _Item.parentId);
      }
    }
    //items in
    var _Items = this.menuPasIn.filter(x => x.id == Id || x.parentId == Id);
    for (const _Item of _Items) {
      _Item.difference = "00";
      _Item.differenceMinutes = 0;
      _Item.userPrdId = this.myId;
      _Item.onTime = 1;
      if (_Item.compType > 0) {
        var _Parentfound = this.menuPasInProduction.find(x => x.id == _Item.id);
        if (!_Parentfound) {
          this.addPASInProductionContainer(_Item);
        }
      }
      else {
        this.menuPasInProduction.push(_Item);
      }
    }
    //drop item and its childrens
    this.menuPasIn = this.menuPasIn.filter(x => x.id != Id && x.parentId != Id);
    return _Items;
  }

  MoveScreenItemToIn(Id) {
    //drop parent container
    var _Item = this.menuPasInProduction.find(x => x.id == Id);
    if (_Item && _Item.parentId > 0) {
      var _Children = this.menuPasInProduction.filter(x => x.parentId == _Item.parentId);
      var _ItemParent = this.menuPasIn.find(x => x.id == _Item.parentId);
      if (!_ItemParent) {
        var _ItemParent = this.menuPasInProduction.find(x => x.id == _Item.parentId);
        if (_ItemParent) {
          _ItemParent.userPrdId = this.myId;
          _ItemParent.onTime = 1;
          this.addPASInContainer(_ItemParent, "--");
        };
      }
      if (_Children.length == 1) {
        this.menuPasInProduction = this.menuPasInProduction.filter(x => x.id != _Item.parentId);
      }
    }
    //items in
    var _Items = this.menuPasInProduction.filter(x => x.id == Id || x.parentId == Id);
    for (const _Item of _Items) {
      if (_Item.compType > 0) {
        var _Parentfound = this.menuPasIn.find(x => x.id == _Item.id);
        if (!_Parentfound) {
          this.addPASInContainer(_Item, _Item.difference);
        }
      }
      else {
        this.menuPasIn.push(_Item);
      }
    }
    //drop item and its childrens
    this.menuPasInProduction = this.menuPasInProduction.filter(x => x.id != Id && x.parentId != Id);
    return _Items;
  }

  OTIFinish(PItems: any[], PId, PCount) {
    this.loadPASInProduction();
  }

  MoveScreenItemToOut(Id) {
    //drop parent container
    var _Item = this.menuPasInProduction.filter(x => x.id == Id);
    if (_Item.length > 0) {
      if (_Item[0].parentId > 0) {
        var _Items = this.menuPasInProduction.filter(x => x.parentId == _Item[0].parentId);
        if (_Items.length == 1) {
          this.menuPasInProduction = this.menuPasInProduction.filter(x => x.id != _Item[0].parentId);
        }
      }
      var _Items = this.menuPasInProduction.filter(x => x.id == Id || x.parentId == Id);
      for (const _Item of _Items) {
        this.menuPasDeleted.push(_Item);
      }
      //drop item and its childrens
      this.menuPasInProduction = this.menuPasInProduction.filter(x => x.id != Id && x.parentId != Id);
    }
    else {
      var _Item = this.menuPasIn.filter(x => x.id == Id);
      if (_Item.length > 0) {
        if (_Item[0].parentId > 0) {
          var _Items = this.menuPasIn.filter(x => x.parentId == _Item[0].parentId);
          if (_Items.length == 1) {
            this.menuPasIn = this.menuPasIn.filter(x => x.id != _Item[0].parentId);
          }
        }
        var _Items = this.menuPasIn.filter(x => x.id == Id || x.parentId == Id);
        for (const _Item of _Items) {
          this.menuPasDeleted.push(_Item);
        }
        //drop item and its childrens
        this.menuPasIn = this.menuPasIn.filter(x => x.id != Id && x.parentId != Id);
      }
    }
    return _Items;
  }

  //b_OrderToOut(PId) {
  //  this._IntervalProductionOn = false;
  //  let _Count = 0;
  //  var _Items = this.MoveScreenItemToOut(PId);
  //  for (const _Item of _Items) {
  //    const _OP: IOrderId = {
  //      orderId: _Item.id
  //    }
  //    this.productionService.PutOrderOut(_OP).pipe(finalize(() => this.OTIFinish(_Items, PId, _Count)))
  //      .subscribe(result => {
  //        if (result.body.isValid) {
  //          this._IntervalProductionOn =true;

  //          _Count++;
  //        }
  //        else {
  //          alert(result.body.error.description);
  //        }
  //      },
  //        (e) => {
  //          console.log(e);
  //        });
  //  }
  //}

  //b_ProcessOrderInProduction(Pid, e: Event) {
  //  e.stopPropagation();
  //  if (this._ClickProductionModeNext) {
  //    this.b_OrderToOut(Pid);
  //  }
  //  else {
  //    this.b_OrderToIn(Pid);
  //    this.b_ClickProductionMode();
  //  }
  //}

  //b_ClickProductionMode() {
  //  this._ClickProductionModeNext = !this._ClickProductionModeNext;
  //  if (!this._ClickProductionModeNext) {
  //    //this._buttonPrdToInTimer = setInterval(() => this.ResetButtonPrdToIn(), 5000)
  //    this.openSB("Seleccione la orden a devolver.")
  //  }
  //}

  ResetButtonPrdToIn() {
    this._ClickProductionModeNext = true;
    clearInterval(this._buttonPrdToInTimer);
  }

  b_back() {
    var _Route=this.routerService.getBackRoute();
    this.router.navigate([_Route], { skipLocationChange: true });
  }

  openSB(msg) {
    this._snackBar.open(msg, '', {
      duration: 5000, horizontalPosition: "center", verticalPosition: "top", panelClass: ['snackbarmsg']
    });
  }
}






